// Browser conditions that reach the window error handler but say nothing about this app, so
// they are dropped before they reach Error Tracking rather than reviewed there every week.
// Anything an app change could prevent belongs at its call site instead, not in this list.
const IGNORED_ERROR_MESSAGES = [
  // The layout engine reporting that a ResizeObserver callback itself resized something, so
  // delivery is deferred one frame. The spec defines that as the normal outcome and nothing
  // is lost; it has no stack in app code and no call site to fix.
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
  // An AbortController firing with no reason attached — a cancelled query or a navigation
  // away from an in-flight request. The abort is the intended behaviour.
  'signal is aborted without reason',
];

export default function isIgnoredRumError(message: string | undefined) {
  if (!message) {
    return false;
  }

  return IGNORED_ERROR_MESSAGES.some((ignored) => message.includes(ignored));
}
